<div class="reports-page-container">
  <div class="back-container" role="button" tabindex="0" (click)="back()" (keydown.enter)="back()" (keydown.space)="back(); $event.preventDefault()">
    <span nz-icon nzType="arrow-left" nzTheme="outline" aria-hidden="true"></span><span>{{ 'symptomAssessment.symptomDetails.back' | translate }}</span>
  </div>
  <app-info-box title="{{ 'reportsPage.reports' | translate }}" description="{{ 'reportsPage.subtitle' | translate }}"></app-info-box>
  <h2>{{ 'reportsPage.folders' | translate }}</h2>
  <nz-divider></nz-divider>
  <div class="folders-container">
    @if (folderSquareContent && folderSquareContent.length > 0) {
      @for (folder of folderSquareContent; track folder.id; let last = $last) {
        <app-folder-square
          [folderSquareData]="folder"
          [ngClass]="last ? 'last-folder' : ''"
          tabindex="0"
          role="button"
          [attr.aria-label]="folder.title ? (folder.title | translate) : null"
          (click)="handleClickFolders(folder.id)"
          (keydown.enter)="handleClickFolders(folder.id)"
          (keydown.space)="handleClickFolders(folder.id); $event.preventDefault()"
        ></app-folder-square>
      }
    }
  </div>
  <h2>{{ 'reportsPage.recent_files' | translate }}</h2>
  <nz-divider></nz-divider>
  <div class="recent-files-container">
    @for (card of recentCardData; track recentCardData) {
      <app-document-card [documentCardData]="card" (emitActionCard)="actionCard($event)"></app-document-card>
    }
  </div>
  <div class="header">
    <h2>{{ 'reportsPage.all_documents' | translate }}</h2>
    <div class="links">
      <span role="button" tabindex="0" (click)="downloadAll()" (keydown.enter)="downloadAll()" (keydown.space)="downloadAll(); $event.preventDefault()"><img src="../../../../public/assets/images/downloadAll.svg" alt="" aria-hidden="true" /> {{ 'buttons.downloadAll' | translate }}</span>
      <span role="button" tabindex="0" (click)="shareAll()" (keydown.enter)="shareAll()" (keydown.space)="shareAll(); $event.preventDefault()"><img src="../../../../public/assets/images/share.svg" alt="" aria-hidden="true" /> {{ 'buttons.shareAll' | translate }}</span>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div class="all-documents-container">
    <app-appointments-table
      [searchEnabled]="true"
      [innerFiltersEnabled]="true"
      [hasCheckbox]="false"
      [hiddenLastSegment]="true"
      [columns]="columns"
      [appointments]="rows"
      [appointmentText]="appointmentsText"
      [innerSelectData]="innerSelectData"
      (actionClicked)="actionCard($event)"
    ></app-appointments-table>
  </div>
</div>
